module.exports = __webpack_public_path__ + "static/img/行驶.6c1f234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/汽车吊/行驶.png
// module id = 5dI0
// module chunks = 76